import {
  EnquiryStatus,
  IEnquiry,
  PagedRequest,
  PagedResponse,
} from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';
// import { Enquiry, EnquiryStatus } from './equiries.types';

const enquiriesApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getEnquiries: build.query<
      PagedResponse<IEnquiry[]>,
      PagedRequest & { status?: EnquiryStatus | ''; search?: string }
    >({
      query: (request) => ({
        url: 'enquiries',
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.data.map(({ _id }) => ({
                type: 'Enquiries' as const,
                id: _id.toString(),
              })),
              { type: 'Enquiries', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Enquiries', id: 'PARTIAL-LIST' }],
    }),
    getEnquiriesCount: build.query<
      { count: number },
      { status?: EnquiryStatus } | void
    >({
      query: (request) => ({
        url: 'enquiries/count',
        method: 'GET',
        params: request || undefined,
      }),
      providesTags: [{ type: 'Enquiries', id: 'PARTIAL-LIST' }],
    }),
    getEnquiry: build.query<IEnquiry, string>({
      query: (id) => ({
        url: `enquiries/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Enquiries' as const, id: result?._id.toString() },
      ],
    }),
    updateEnquiry: build.mutation<
      IEnquiry,
      { id: string; data: Partial<IEnquiry> }
    >({
      query: (request) => ({
        url: `enquiries/${request.id}`,
        method: 'PUT',
        body: request.data,
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Enquiries', id: 'PARTIAL-LIST' },
        { type: 'Enquiries', id: result?._id.toString() },
      ],
    }),
  }),
});

export const {
  useGetEnquiriesQuery,
  useGetEnquiriesCountQuery,
  useUpdateEnquiryMutation,
  useGetEnquiryQuery,
} = enquiriesApi;
